import { render, staticRenderFns } from "./FaqPosts.vue?vue&type=template&id=bc0696dc&scoped=true&"
import script from "./FaqPosts.vue?vue&type=script&lang=js&"
export * from "./FaqPosts.vue?vue&type=script&lang=js&"
import style0 from "./FaqPosts.vue?vue&type=style&index=0&id=bc0696dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0696dc",
  null
  
)

export default component.exports